//--
import request from "../../../core/wrappers/axios-wrapper";
import { ApiURL } from "../../../types/constants/apiUrls/api-urls";
 

import { RequestType } from "../../../types/enums/request-enums";
 //#region comment metod
 const ListGreetingNotes=()=>request({
  url: ApiURL.Query.ListOfGreetingNotes,
  method: RequestType.GET,
 });
 
 

const GreetingNotesQuery = {
  ListGreetingNotes,
 
};

export default GreetingNotesQuery;
